export default __webpack_public_path__ + "static/media/explore.18cf8af9.mp4";